var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-3{fill:#00ff6f}.prefix__cls-2,.prefix__cls-5{fill:none}.prefix__cls-2,.prefix__cls-3{stroke:#fff;stroke-width:2px}.prefix__cls-4{stroke:none}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_288",
    "data-name": "Group 288",
    transform: "translate(-987 -154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_285",
    "data-name": "Group 285",
    transform: "translate(-108 -814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_70",
    d: "M0 0H56V56H0z",
    "data-name": "Rectangle 70",
    transform: "translate(1095 968)",
    style: {
      fill: "#00ff6f"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_287",
    "data-name": "Group 287",
    transform: "translate(12678.2 17233.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Rectangle_81",
    className: "prefix__cls-2",
    "data-name": "Rectangle 81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H17V17H0z",
    className: "prefix__cls-4",
    transform: "translate(-11672 -17061.318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H16V16H1z",
    className: "prefix__cls-5",
    transform: "translate(-11672 -17061.318)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_107",
    d: "M-11548.5-17035h5.393l3.123 4.414v6.344h-8.516",
    className: "prefix__cls-2",
    "data-name": "Path 107",
    transform: "translate(-106.782 -21.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_108",
    d: "M-11548.5-17009h8.516",
    className: "prefix__cls-2",
    "data-name": "Path 108",
    transform: "translate(-106.782 -42.536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_109",
    d: "M-11548.5-17009h4.73",
    className: "prefix__cls-2",
    "data-name": "Path 109",
    transform: "translate(-131.7 -43.86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_110",
    d: "M-11548.5-17009h4.73",
    className: "prefix__cls-2",
    "data-name": "Path 110",
    transform: "translate(-131.7 -47.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_111",
    d: "M-11548.5-17009h4.73",
    className: "prefix__cls-2",
    "data-name": "Path 111",
    transform: "translate(-131.7 -40.644)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_56",
    className: "prefix__cls-3",
    "data-name": "Ellipse 56",
    transform: "translate(-11654 -17047.318)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    className: "prefix__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2,
    className: "prefix__cls-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_57",
    className: "prefix__cls-3",
    "data-name": "Ellipse 57",
    transform: "translate(-11667 -17047.318)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    className: "prefix__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2,
    className: "prefix__cls-5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.c2e5afb1203ff46f1379910754ab5460.svg";
export { ForwardRef as ReactComponent };